export const information = {
  site: "qq88",
  cskh_url: "https://qq88cskh8.com/",
  cskh_home: "https://www.qq8841.com/",
  endpoint: "https://api-freecode-qq88.freecodevip.org",
  // endpoint: "http://localhost:5039",
  key_free: "att.code.free-code.qq88@2030$",
};
